export const validateOrganizationForm = (values) => {
    var _a, _b;
    const errors = {};
    if (!values) {
        return errors;
    }
    if (!((_b = (_a = values.organization) === null || _a === void 0 ? void 0 : _a.name) === null || _b === void 0 ? void 0 : _b.length)) {
        errors.name = 'Required';
    }
    return errors;
};
